// @flow

import { getInternationalPhone } from '@services/phone';

import type { PersonalData } from '../types';

export const getUserAddress = (data: PersonalData): string => {
  const addressStreet = data?.attributes?.address_street || '';
  const addressCity = data?.attributes?.address_city || '';
  const addressCode = data?.attributes?.address_code || '';
  const addressNumber = data?.attributes?.address_number || '';

  return `${addressStreet} ${addressNumber}, ${addressCode} ${addressCity}`;
};

export default (data: PersonalData): PersonalData => ({
  ...data,
  attributes: {
    ...data.attributes,
    avatar_url: data.attributes ? `${data.attributes.avatar_url}?rnd=${Math.random()}` : '',
    address: data.attributes ? getUserAddress(data) : '',
    international_phone: data.attributes
      ? getInternationalPhone(data?.attributes?.phone_code, data?.attributes?.phone)
      : ''
  }
});
